import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getMappingDetail(uuid) {
  return request({
    url: URL.sys.ediMappingDetail,
    method: 'get',
    params: { uuid }
  })
}
export function getMappingTypeList(params) {
  return request({
    url: URL.sys.ediMappingType,
    method: 'get',
    params
  })
}
export function getMappingList(params) {
  return request({
    url: URL.sys.ediMapping,
    method: 'get',
    params
  })
}

export function getMappingListByPage(params) {
  return request({
    url: URL.sys.ediMappingPage,
    method: 'get',
    params
  })
}
export function saveMapping(data, uuid) {
  return request({
    url: URL.sys.ediMapping,
    method: uuid ? 'put' : 'post',
    data
  })
}

export function batchSaveMapping(data) {
  return request({
    url: URL.sys.saveEdiMappingUrl,
    method: 'post',
    data
  })
}

export function delMapping(uuid) {
  return request({
    url: URL.sys.ediMapping,
    method: 'delete',
    params: { uuid }
  })
}
